/*eslint-disable*/
import { Box, Button, TextField, InputLabel } from "@mui/material";

import React from "react";

import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import {
  
  AddNewSchedule,
  GetPlayers,
} from "../../../../api/AuthenticationServices";

const NewSchedule = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("authorizeToken"), // your authorization token here
    },
  };

  //Sending data
  const sendData = async (e, values) => {
    // console.log("Form Submit Values", values);

    console.log(values);
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("title", values.acTitle);
      formData.append("place", values.acPlace);
      formData.append("date", values.acDate);
      formData.append("description", values.acDescription);
      formData.append("opponent", values.acOpponent);
      formData.append("time", values.acTime);

      const res = await AddNewSchedule(formData, config);

      if (res.data.status === "success") {
        // console.log("Inside Successs");
        alert(res.data.message);
        navigate("/admin/viewschedules");
      }
    } catch (e) {
      //FIX : Message of error need to be shown to user Only Axios Error Displaying
      alert(e);
    }
  };
  return (
    <div>
      <Box m="20px">
        <Header title="NEW SCHEDULES" subtitle="Create a New Schedule" />

        <Formik
          // onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            // console.log(values,handleChange)
            <form onSubmit={(e) => sendData(e, values)}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Title"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acTitle}
                  name="acTitle"
                  error={!!touched.acTitle && !!errors.acTitle}
                  helperText={touched.acTitle && errors.acTitle}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="date"
                  label="Date of Game"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDate}
                  name="acDate"
                  error={!!touched.acDate && !!errors.acDate}
                  helperText={touched.acDate && errors.acDate}
                  sx={{ gridColumn: "span 4" }}
                />

                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Place"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acPlace}
                  name="acPlace"
                  error={!!touched.acPlace && !!errors.acPlace}
                  helperText={touched.acPlace && errors.acPlace}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Time"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acTime}
                  name="acTime"
                  error={!!touched.acTime && !!errors.acTime}
                  helperText={touched.acTime && errors.acTime}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Opponent"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acOpponent}
                  name="acOpponent"
                  error={!!touched.acOpponent && !!errors.acOpponent}
                  helperText={touched.acOpponent && errors.acOpponent}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="filled"
                  type="text"
                  label="Description"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.acDescription}
                  name="acDescription"
                  error={!!touched.acDescription && !!errors.acDescription}
                  helperText={touched.acDescription && errors.acDescription}
                  sx={{ gridColumn: "span 4" }}
                />
              </Box>

              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  type="submit"
                  disabled={false}
                  color="secondary"
                  variant="contained"
                >
                  Create New Schedule
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </div>
  );
};

const checkoutSchema = yup.object().shape({
  acTitle: yup.string().required("required"),
  acDate: yup.string().required("required"),
  acPlace: yup.string().required("required"),
  acOpponent: yup.string().required("required"),
  acDescription: yup.string().required("required"),
  acTime: yup.string().required("required"),
});
const initialValues = {
  acTitle: "",
  acPlace: "",
  acDate: "",
  acOpponent: "",
  acDescription: "",
  acTime: "",
};

export default NewSchedule;
